// extracted by mini-css-extract-plugin
var _1 = "Layout_appContainer__uDxeJ";
var _2 = "Layout_footerWrapper__YWkQK";
var _3 = "768px";
var _4 = "'../../shared.module.css'";
export { _1 as "appContainer", _2 as "footerWrapper", _3 as "md", _4 as "shared" }
